<div class="form-group w-100" (clickOutside)="clickOutside()">
  <div class="Typeahead Typeahead--twitterUsers">
    <div class="u-posRelative d-flex align-items-center max-h-55">
      <app-common-svg-icon [icon]="'search'"></app-common-svg-icon>
      <div class="search-nav">
        <input
          class="demo-input py-0 Typeahead-input form-control-plaintext w-100 serch-input"
          type="text"
          placeholder="Search .."
          [(ngModel)]="text"
          [ngModelOptions]="{ standalone: true }"
          (keyup)="findProducts(text)"
          (keydown.enter)="redirectToSearch($event.target)"
        />
      </div>
    </div>
    @if (productList.length) {
    <div
      class="Typeahead-menu custom-scrollbar"
      [class.is-open]="searchResult"
      id="search-outer"
    >
      @for (product of productList | slice : 0 : 8; track product) {
      <div
        class="ProfileCard u-cf"
        [routerLink]="['/product', product._id]"
        (click)="removeFix()"
      >
        <div class="ProfileCard-details">
          <div class="ProfileCard-realName">
            <img [src]="product?.mainImage" class="img-course"/>
            <a class="realname">{{ product?.name }}</a>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
<div
  class="Typeahead-menu is-open"
  [class.is-open]="searchResultEmpty"
  (clickOutside)="clickOutside()"
>
  <div class="tt-dataset tt-dataset-0">
    <div class="EmptyMessage">Opps!! There are no result found.</div>
  </div>
</div>
